export class LeveragedAuthorization {
  leveragedAuthorizationId?: number;
  clientITProfileId?: number;
  name?: string;
  owner?: string;
  date?: number;
  fedramp_identifier?: string;
}
